import { onMounted, onUnmounted } from "vue";

export function useScrollReveal() {
  let observer: IntersectionObserver | null = null;
  let mutationObserver: MutationObserver | null = null;

  function observeElements() {
    document.querySelectorAll("[data-reveal]:not(.is-visible)").forEach((el) => {
      if (!el.hasAttribute("data-reveal-observed")) {
        el.setAttribute("data-reveal-observed", "");
        observer?.observe(el);
      }
    });
  }

  onMounted(() => {
    const prefersReduced = window.matchMedia("(prefers-reduced-motion: reduce)").matches;

    if (prefersReduced) {
      document.querySelectorAll("[data-reveal]").forEach((el) => {
        el.classList.add("is-visible");
      });
      return;
    }

    observer = new IntersectionObserver(
      (entries) => {
        for (const entry of entries) {
          if (entry.isIntersecting) {
            entry.target.classList.add("is-visible");
            observer?.unobserve(entry.target);
          }
        }
      },
      { threshold: 0.1, rootMargin: "0px 0px -40px 0px" },
    );

    observeElements();

    // Watch for new elements added to the DOM (e.g. after route changes)
    mutationObserver = new MutationObserver(() => {
      observeElements();
    });
    mutationObserver.observe(document.body, { childList: true, subtree: true });
  });

  onUnmounted(() => {
    observer?.disconnect();
    mutationObserver?.disconnect();
  });
}
